import PropTypes from 'prop-types';
import React from 'react';
import injectSheet from 'react-jss/lib/injectSheet';
import { connect } from 'react-redux';
import { compose } from 'redux';
import theme from '../../styles/theme';

const Error = ({
  classes,
  reloadPage,
}) => (
  <div className={classes.error}>
    <div className={classes.icon} />
    <div>
      <div className={classes.title}>
        Error loading job list
      </div>

      <div>
        Please try reloading the page.
      </div>

      <div className={classes.cta} onClick={() => reloadPage()} onKeyDown={() => reloadPage()} role="button" tabIndex="0">
        Reload page
      </div>
    </div>
  </div>
);

Error.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  reloadPage: PropTypes.func.isRequired,
};

const mapDispatchToProps = () => ({
  // eslint-disable-next-line no-undef
  reloadPage: () => window.location.reload(false),
});

export default compose(
  connect(mapDispatchToProps),
  injectSheet({
    icon: {

    },
    error: {
      borderRadius: 4,
      border: '1px solid #ff0000',
      padding: '20px 10px',
      display: 'flex',
      backgroundColor: '#ff000033',
    },
    title: {
      fontWeight: 600,
      fontSize: 16,
      marginBottom: 10,
    },
    cta: {
      marginTop: 20,
      textDecoration: 'underline',
      fontWeight: theme.fonts.boldWeight,
      cursor: 'pointer',
    },
  }),
)(Error);
